module.exports = __webpack_public_path__ + "img/head_title_text_news.18785a69.png";